var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "159.38 -796 641.24 637.051",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m692.15-170.69-211-209.46q-22.3 10.3-48.51 16.73-26.21 6.42-53.26 6.42-90.66 0-155.33-64.17-64.67-64.16-64.67-154.83 0-27.78 5.27-53.43T182-677.15l139.38 137.84 97.7-97.69-136.31-137.85q22.08-10.07 46.42-15.61t50.19-5.54q91.67 0 155.84 65.17 64.16 65.16 64.16 156.02 0 27.43-6.03 49.62-6.04 22.19-17.12 42.96l213.46 214q10.93 11.54 10.93 27.88 0 16.35-10.76 27.1l-45.26 44.27q-10.84 10.75-26.18 9.98t-26.27-11.69m27.08-18 54.23-53.23-235.77-233.77q17.69-25.54 23.69-54.04t6-45.27q0-79.92-65.57-142.96Q436.23-781 337.69-764l107.39 106.38q8.69 8.88 8.69 20.71t-8.98 20.74l-103.5 102.65q-8.98 8.9-20.09 8.9-11.1 0-19.43-8.69L191.38-623.69q-17.69 109 46.04 171.84Q301.15-389 379.38-389q17.52 0 48.03-6.62 30.51-6.61 58.05-26.84zM476-484.92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuild);
export default __webpack_public_path__ + "static/media/build.eab16ce89889096132f6c54a6a0c13aa.svg";
export { ForwardRef as ReactComponent };